import { SkipLimitPageSpec } from '@warebee/shared/athena-db-model';
import { KeysMatching } from '@warebee/shared/common';
import { StringSearchFilter } from '@warebee/shared/data-access-api-dto';
import { SortDirection } from '@warebee/shared/engine-model';
import { InferResult, sql } from 'kysely';
import { datasetQueryBuilder } from '../datasetQueryBuilder';
import { DatasetQueryBuilderParams } from '../datasetQueryBuilder.types';
import { getPicklistLineQueryBuilder } from '../picklistSet/picklistLineQueryBuilder';
import { ordersQueryBuilder } from './ordersQueryBuilder';

const orderSetStatsDummyQuery = orderJobsQueryBuilder({} as any)
  .selectFrom('order_line_job')
  .selectAll();

export type OrderJobsDataRows = InferResult<typeof orderSetStatsDummyQuery>;
export type OrderJobsDataRow = OrderJobsDataRows[number];
export type OrderJobsDataColumn = keyof OrderJobsDataRow;

export type OrderJobsSortBy = {
  direction?: SortDirection;
  field: OrderJobsDataColumn;
};

export type OrderJobsQueryBuilderPagedClientParams = {
  page?: SkipLimitPageSpec;
  sortBy?: OrderJobsSortBy[];
};

export type OrderJobsFieldWithStringFilter = KeysMatching<
  OrderJobsDataRow,
  string
>;

export type OrderJobsFilterBy = Partial<
  Record<OrderJobsFieldWithStringFilter, StringSearchFilter>
>;

export type OrderJobsQueryBuilderParams = {
  picklistSet: DatasetQueryBuilderParams;
  orderSet: DatasetQueryBuilderParams;
};

export type OrderJobsQueryBuilderPagedParams = OrderJobsQueryBuilderParams &
  OrderJobsQueryBuilderPagedClientParams;

export function orderJobsQueryBuilder(params: OrderJobsQueryBuilderParams) {
  let builder = datasetQueryBuilder
    .with(
      cte => cte('job_lines'),
      db => {
        return getPicklistLineQueryBuilder(params.picklistSet, db);
      },
    )
    .with(
      cte => cte('orders'),
      db => {
        return ordersQueryBuilder(params.orderSet, db);
      },
    )
    .with(
      cte => cte('order_line_job'),
      db => {
        return db
          .selectFrom([
            'job_lines',
            sql`UNNEST(${sql.ref('orderRefsArray')})`.as<'oRef'>(
              sql`oRef(${sql.ref('orderLineKey')})`,
            ),
          ])
          .selectAll('job_lines')
          .select(({ fn }) => [
            fn<number>('cardinality', [sql.ref('orderRefsArray')]).as(
              'affectedOrderLinesCount',
            ),
            sql<string>`${sql.ref('orderLineKey')}[1]`.as('orderKey'),
            sql<number>`cast( ${sql.ref('orderLineKey')}[2] as integer)`.as(
              'orderLine',
            ),
          ]);
      },
    );

  return builder;
}
